// Northern Illinois University's bachelor's majors (#2739). Read on
// 2026-10-01 from NIU's official 2026-2027 Undergraduate Catalog
// (catalog.niu.edu, Undergraduate Programs, rendered in a browser because the
// catalog answers 202 to automated reads): every entry under Majors, with the
// degree as the catalog writes it ("B.A. or B.S." where a major leads to
// either). The catalog lists majors A to Z without colleges, so this is one
// group. Minors, the per-college contract major listings (the one Contract
// Major entry under Majors is kept), certificates, educator licensure
// programs, degrees with honors, emphases and the accelerated bachelor's and
// graduate programs are left out.
const majors = {
    "slug": "northern-illinois-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in NIU's official 2026-2027 Undergraduate Catalog. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor's majors, A to Z",
            "source": {
                "label": "NIU Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.niu.edu/content.php?catoid=65&navoid=3480"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "B.S."
                },
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Applied Management",
                    "degree": "B.S."
                },
                {
                    "name": "Art",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Art and Design Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Art History and Visual Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studio and Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Bachelor of General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Communicative Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Contract Major",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Dance Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Earth, Atmosphere and Environment",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Engineering Technology",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Human Development and Family Sciences, Comprehensive Major",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechatronics Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Meteorology",
                    "degree": "B.S."
                },
                {
                    "name": "Middle Level Teaching and Learning",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Nonprofit and NGO Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Operations and Information Management",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Physical Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Public Service Leadership (School of Public and Global Affairs)",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Sport Management",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
